var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoggles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.73,92.94s-6.26,35.19,15.43,48.21,43.51-6.82,45-26.1c0,0-.72-7.17,7.71-7.17,7.72,0,7.24,7.72,7.24,7.72,1.44,19.28,22.89,38.56,44.59,25.55s15.42-48.21,15.42-48.21S111.48,71.25,40.73,92.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.07,93.66a70.72,70.72,0,0,0-.82-10.36s-63.81-21.7-133.69,0a70.72,70.72,0,0,0-.82,10.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.12,112.46h11.33V99.69H178.12M39.65,112.46H28.32V99.69H39.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.3,117l-23.14,26.52m17.36-38.33-9.16,10.85M63.27,99.69l-9.16,10.84M92,84l-33,39.29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoggles);
export default __webpack_public_path__ + "static/media/GOGGLES.5fb9c396e55cbe8a6efa30690bfaab43.svg";
export { ForwardRef as ReactComponent };